'use client'

import {
  Button,
  Flex,
  Heading,
  Image,
  Stack,
  Text,
} from '@chakra-ui/react'
import { COLORS } from '../../../colors'
import FormModal from './formModal'

export default function Hero() {
  return (
    <Stack minH={'100vh'} direction={{ base: 'column', md: 'row' }} fontFamily={"Montserrat"} bg={COLORS.brand4}>
      <Flex p={8} flex={1} align={'center'} justify={'center'} bg={COLORS.brand4}>
        <Stack spacing={6} w={'full'} maxW={'lg'} >
          <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
            <Text
              fontFamily={"Montserrat"}
              as={'span'}
              position={'relative'}
              color={COLORS.brand1}
            >
              Somerset
            </Text>
            <Text fontFamily={"Montserrat"}  as={'span'}>
              {' '} Language Centre
            </Text>{' '}
          </Heading>
          <Text fontSize={{ base: 'md', lg: 'lg' }} color={'gray.500'}>
          ¡Domina el inglés con nosotros! Aprende de manera dinámica y efectiva en nuestra academia. Únete a nuestra comunidad y abre un mundo de oportunidades.
          </Text>
          <Stack direction={{ base: 'column', md: 'row' }} spacing={4}>
            <FormModal />
          </Stack>
        </Stack>
      </Flex>
      <Flex flex={1}>
        <Image
          alt={'Login Image'}
          objectFit={'cover'}
          src={
           "/herophoto.jpeg"
          }
        />
      </Flex>
    </Stack>
  )
}